import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import CheckBlockGroup from 'components/consumer/CheckBlockGroup';
import { GRADE_NUMERAL_BY_VALUE } from 'commons/constants';
const MobileGradeFilters = t0 => {
  const $ = _c(9);
  const {
    leatherGrades,
    toggleSelectedGrade,
    selectedGrades
  } = t0;
  let t1;
  if ($[0] !== leatherGrades || $[1] !== selectedGrades || $[2] !== toggleSelectedGrade) {
    let t2;
    if ($[4] !== selectedGrades || $[5] !== toggleSelectedGrade) {
      t2 = grade => ({
        label: `Grade ${GRADE_NUMERAL_BY_VALUE[grade] || grade}`,
        id: grade,
        isSelected: selectedGrades.includes(grade),
        onClick: () => {
          toggleSelectedGrade(grade);
        }
      });
      $[4] = selectedGrades;
      $[5] = toggleSelectedGrade;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = leatherGrades.map(t2);
    $[0] = leatherGrades;
    $[1] = selectedGrades;
    $[2] = toggleSelectedGrade;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ShopByHeaderSection label="Grade"><CheckBlockGroup items={t1} /></ShopByHeaderSection>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
MobileGradeFilters.propTypes = {
  leatherGrades: PropTypes.arrayOf(PropTypes.number),
  toggleSelectedGrade: PropTypes.func,
  selectedGrades: PropTypes.arrayOf(PropTypes.number)
};
export default MobileGradeFilters;